import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Swal from 'sweetalert2';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { Cloudinary } from '@cloudinary/angular-5.x';
import { CourseService } from '../../../_services/course.service';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../_services/global.service';
import { IDeactivateComponent } from '../../../_models/i-deactivate';
import { Location } from '@angular/common';

@Component({
  selector: 'iq-central-front-end-add-pdf',
  templateUrl: './add-pdf.component.html',
  styleUrls: ['./add-pdf.component.scss'],
})
export class AddPdfComponent
  implements OnInit, OnDestroy, IDeactivateComponent
{
  sub: Subscription = new Subscription();
  cloudName = 'cctlf-org';
  unsignedUploadPreset = 'n3zbglni';
  cloudinaryUrl = `https://api.cloudinary.com/v1_1/${this.cloudName}/upload`;
  uploadProgress = 0;
  file: any;
  contentForm: FormGroup;
  filePath: any;
  url: any;
  lessonId: any;
  courseCode: any;
  go: boolean;
  duration: any;
  name: any;
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [['bold']],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };
  contentType: any;
  hasBaseDropZoneOver: boolean;
  uploader: FileUploader;
  title: string;
  response: any;
  fileName: any;
  delete_token: any;
  completed: boolean = false;
  requiredFileType: boolean;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _toastr: ToastrService,
    private cloudinary: Cloudinary,
    private _course: CourseService,
    private _global: GlobalService,
    private location: Location
  ) {
    this.title = '';
  }

  ngOnInit(): void {
    this.initContentForm();
    this.lessonId = this.route.snapshot.paramMap.get('id');
    this.courseCode = this.route.snapshot.paramMap.get('code');

    const uploaderOptions: FileUploaderOptions = {
      url: this.cloudinaryUrl,
      autoUpload: true,

      // Use xhrTransport in favor of iframeTransport
      isHTML5: true,
      // Calculate progress independently for each uploaded file
      removeAfterUpload: true,
      // XHR request headers
      headers: [
        {
          name: 'X-Requested-With',
          value: 'XMLHttpRequest',
        },
      ],
    };
    this.uploader = new FileUploader(uploaderOptions);
    this.uploader.onWhenAddingFileFailed = (file, filter) => {
      this.requiredFileType = true;
    };
    this.uploader.onBuildItemForm = (fileItem: any, form: FormData): any => {
      form.append('upload_preset', this.cloudinary.config().upload_preset);

      form.append('resource_type', 'auto');
      let tags = 'content';
      if (this.title) {
        form.append('context', `photo=${this.title}`);
        tags = `content,${this.title}`;
      }
      form.append('folder', 'pdf Contents For IQCentral');
      form.append('tags', tags);
      fileItem.withCredentials = false;
      return { fileItem, form };
    };
    this.uploader.onSuccessItem = (item, response, status, Headers) => {
      if (response) {
        const res = JSON.parse(response);
        this.url = res.secure_url;
        this.filePath = res.secure_url;
        this.duration = this.calculateReadingTimeInSeconds(res.pages);
        this.fileName = res.original_filename;
        this.contentType = res.format;
        this.delete_token = res.delete_token;
        console.log(res, this.contentType);
      }
    };
    this.uploader.onProgressItem = (fileItem: any, progress: any) => {
      this.go = true;
      this.fileName = fileItem;
      this.uploadProgress = progress;
    };

    this.uploader.onErrorItem = (status) => {
      this._global.handleNetworkError();
    };
  }
  initContentForm() {
    this.contentForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

  finish() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This content will be saved and you will be taken to your courses',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Save',
    }).then((result) => {
      if (result.value) {
        this.createContentpdf();
      }
    });
  }

  addMoreContent(path) {
    this._global.showSpinner();
    this.createContentpdf(path);
  }

  createContentpdf(path?) {
    if (this.contentType) {
      if (this.contentType === 'pdf') {
        const payload = this.contentForm.value;
        payload.contentType = 'pdf';
        payload.duration = this.duration;
        payload.fileName = this.fileName;
        payload.filePath = this.filePath;
        payload.lessonId = this.lessonId;

        this.sub.add(
          this._course.createLessonContentPdf(payload).subscribe({
            next: (res) => {
              this.completed = true;
              if (path) {
                this._global.hideSpinner();
                this.router.navigate(['courses/add-lesson', this.courseCode]);
              } else {
                this.router.navigate(['courses']);
              }
            },
          })
        );
      }
    } else {
      this._toastr.warning(
        'Unsupported format please make sure you are uploading a file with the supported format'
      );
    }
  }
  deleteFileFromCloudiary() {
    this.sub.add(
      this._course.deleteFileFromCloudinary(this.delete_token).subscribe({
        next: (res) => {},
      })
    );
  }

  canExit(): boolean | Promise<boolean> {
    if (!this.completed && this.contentForm.dirty) {
      if (
        confirm(
          'Are you sure you want to leave this page? Any unsaved changes will be lost'
        )
      ) {
        this.deleteFileFromCloudiary();
        return true;
      }
    }
    return true;
  }

  /**
   * Calculates the total seconds required to read a PDF based on its number of pages.
   *
   * @param totalPages - The total number of pages in the PDF.
   * @param secondsPerPage - Average seconds spent reading one page (default is 120 seconds per page).
   * @returns Total reading time in seconds.
   */
  calculateReadingTimeInSeconds(
    totalPages: number,
    wordsPerPage: number = 250,
    wordsPerMinute: number = 200
  ): number {
    if (totalPages <= 0) {
      return 0;
    }

    if (wordsPerPage <= 0) {
      return 0;
    }

    if (wordsPerMinute <= 0) {
      return 0;
    }

    // Calculate total words in the PDF
    const totalWords = totalPages * wordsPerPage;

    // Calculate reading time in minutes
    const readingTimeInMinutes = totalWords / wordsPerMinute;

    // Convert minutes to seconds
    const readingTimeInSeconds = readingTimeInMinutes * 60;

    // Return the result rounded to the nearest second
    return Math.round(readingTimeInSeconds);
  }

  openFileInput() {
    document.getElementById('file').click();
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  goBack() {
    this.location.back();
  }
}
